import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IOption } from '../../../../ui/interfaces/option';
import { Subject } from 'rxjs';
import { CashKey } from '../../cash/cash-key';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { CodeService } from '../../../../services/ServiceEntity/code.service';
import { CUserService } from '../../../../services/ServiceEntity/c-user.service';
import { AccountUserService } from '../../../../services/ServiceEntity/account-user.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CountryColumnName } from '../../countries/country-column-name';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CostsRuleService } from '../../fees/costs-rule.service';
import { CountryService } from '../../countries/countries.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, takeUntil } from 'rxjs/operators';
import { BASE_URL } from '../../../../../environments/environment';
import {
  CONTAINER_DIALOG_POPUP,
  MT_FORM_CASH_CLASS,
  MW_MEDIUM_POPUP_CLASS,
  POPUP_CONTAINER_CLASS,
  SUFFIX_ICON_FORM
} from '../../../../shared/constant/css-style/css-class.constant';
import { ITransaction, Transaction } from '../../../../model/transaction.model';
import { TIME_LONG_REQUEST, TIME_MEDIUM_REQUEST, TIME_MIN_X_REQUEST } from '../../../../shared/constant/request.contant';
import { IMobileAccount } from '../../../../model/mobile-account.model';
import { STATUS } from '../../../../model/account.model';
import { Content } from '../../../../ui/interfaces/modal';
import { BaseDynamicComponent } from '../../../../shared/layouts/base-dynamic.component';
import { IBuildingFormByStep, INextForm } from '../dynamic-form.init';
import { DynamicService } from '../../../../services/dynamic.service';
import { DynamicFormModel } from '../../../../model/champs_formulaire/dynamic-form.model';
import { ChampsFormulaireService } from '../../champs_formulaires/champs_formulaires/champs-formulaire.service';
import { TransactionsService } from '../../../../services/ServiceEntity/transactions.service';
import {
  ID_SERVICE_ITEM_RETRAIT_ALL_CODE_CASH,
  SERVICE_ITEM_ID_INFORMATION_CODE_COMPLET
} from '../../../../shared/constant/service-item.constant';
import { DataFormDynamic } from '../../cash/services/base-validation.service';
import { RetraitCodePartielInfosComponent } from '../../cash/retrait-code-partiel-infos/retrait-code-partiel-infos.component';
import { SIZE_MEDIUM_POPUP, SIZE_MIN_POPUP } from '../../../../shared/constant/css-style/css-size.constant';
import { RetraitCodeCompletInfosComponent } from '../../cash/retrait-code-complet-infos/retrait-code-complet-infos.component';
import { PRINCIPAL } from '../../../../model/account-ressource.model';
import { ICashModel } from '../../cash/cash-data-model';

/**
 * Permet à une personne de retirer soit
 * tout le montant de son solde.
 */
@Component({
  selector: 'app-retrait-code-complet',
  templateUrl: './retrait-code-complet.component.html',
  animations: [fadeIn]
})
export class RetraitCodeCompletComponent extends BaseDynamicComponent
  implements OnInit, OnDestroy {

  transfertCode: UntypedFormGroup;
  retraitCode: UntypedFormGroup;
  allCachOutForm: UntypedFormGroup;

  theDialogRef: MatDialogRef<RetraitCodeCompletComponent>;

  loadingMessagesForm: boolean;
  loadingCodeForm: boolean;
  loadingAllCashOut: boolean;
  loadingTransfertCompte: boolean;

  CurentUser: any;
  CurentUserCuser: any;
  currentMobileAccount: any;
  cUserMobileAccount: any;
  accountNumber: any;
  countrylist: IOption[];
  country: any;
  countries: any;
  SelectedContry: any;
  //
  sentAmount: number;
  countryTrader: string;
  moneySource: string;
  moneyDest: string;
  error: string;
  //
  CountryDestID: any;

  //Tabs
  TabsEnvoiCode: boolean;
  TabsRetraitCode: boolean;
  TabsTransFert: boolean;
  retraitCodeForm: boolean;
  //retrait Code
  //All cash, partial cash and Transfert Compte
  AllcashOutPane = false;
  PartialCashPane = false;
  //transfertCompte
  transfertCompteSuccess = false;
  transfertCompteFail = false;
  transfertCompteERROR: any;

  buildingFormData: IBuildingFormByStep;

  private subs$ = new Subject<void>();

  /* Contient toutes les données pour pouvoir effectuer
  * n'importe quelle type de transaction */
  dataObj: DataFormDynamic = {};

  //Identity type
  identityType: IOption[] = [
    {
      'label': 'CNI',
      'value': 'CNI'
    },
    {
      'label': 'Passe Port',
      'value': 'Passe Port'
    },
    {
      'label': 'Permis conduire',
      'value': 'Permis conduire'
    },
    {
      'label': 'Carte Résident',
      'value': 'Carte Résident'
    }
  ];

  finalAllCashOutVal: any;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICashModel,
    private dialog: MatDialog,
    protected dynamicService: DynamicService,
    private transactionService: TransactionsService,
    private cashKey: CashKey,
    private formService: FormService,
    private accountService: AccountService,
    private formulaireService: ChampsFormulaireService,
    private codeService:CodeService,
    private cUserService:CUserService,
    private mAccountService:AccountUserService,
    private dialogRef: MatDialogRef<RetraitCodeCompletComponent>,
    private columnName: CountryColumnName,
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private modal: TCModalService,
    private costsRuleService: CostsRuleService,
    private countryService: CountryService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(dynamicService, store, httpSv);
    this.theDialogRef = this.dialogRef;
    this.data.cashDataModel.dialogRef = dialogRef;
    console.log('## construct all cash out');
   // this.initAllCashOutForm();
    this.countrylist = [];

    let transfertCode = this.fb.group({});

    this.buildingFormData = {
      lastIndexForm: 0,
      previousIndexForm: 0,
      dynamicFormModels: [],
      bodyModels: [],
      headerModels: []
    }

    this.dataObj.nextFormData = {
      init: false,
      formulaire: transfertCode,
      formBuilder: this.fb,
      dynamicFormModelsDefault: null,
      hasBuiltList: false,
      tabOption: [],
      buildingFormByStep: this.buildingFormData
    }
  }

  ngOnInit(): void {
    console.log('## init all cash out');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        console.log('## get account');
        this.CurentUser = account;
        console.log('POINT CASH', this.CurentUser);
        this.getCurrentCuser();
        this.getData('assets/data/table.json', 'tableData',
          'setLoaded');
        this.getData(`${BASE_URL}countries`, 'countries',
          'initCountry');
        // récupère infos sur le code.
        const code = this.data.cashDataModel.dataCode.code;
        const data = new FormData();
        console.log('## the code: ', code);
        data.set('valueCode', code);
        data.set('serviceItemId', '' + this.data.cashDataModel.dataCode.serviceItemIdInfos);
        this.showKeys(data);
        this.codeService.verifCodeDynamic(data)
          .subscribe((result) => {
            console.log('### RETRAIT CASH RESULT', result.body);
            this.data.cashDataModel.setCode(result.body);
          }, err => {
            console.log(err);
         });
        let params = new HttpParams();
        params = params.set('idServiceItem', String(this.data.cashDataModel.dataCode.idServiceItem));
        this.formulaireService.query(this.formulaireService.dynamicFormApi, params)
          .pipe(map(res => res.body))
          .subscribe((res: DynamicFormModel[]) => {
            console.log('## success get list forms');
            console.log('## res: ', res);
            this.nextForm(res, this.dataObj.nextFormData);
          }, error => {
            console.log('## error get list forms: ', error);
          });
      });
  }

  getHeaders() {
    return this.buildingFormData.headerModels;
  }

  ngOnDestroy() {
    console.log('## destroy envoi code');
    this.formService.free(this.subs$);
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  getMtFormClass() {
    return MT_FORM_CASH_CLASS;
  }

  getMwMediumClass() {
    return MW_MEDIUM_POPUP_CLASS;
  }

  getInit() {
    return this.dataObj.nextFormData.init;
  }

  AllcashOut() {
    this.AllcashOutPane = true;
    this.PartialCashPane = false;
  }

  /**
   * Permet de charger les éléments du formulaire
   * de l'étape suivante.
   * @param res tous les champs du formulaire.
   */
  buildPreviousForm(res: DynamicFormModel[]) {
    this.dataObj.nextFormData.init = false;
    let formList = [];
    if (res.length > 0 && this.buildingFormData.previousIndexForm >= 0) {
      let i = this.buildingFormData.previousIndexForm;
      this.buildingFormData.lastIndexForm = i+1;
      let next = res[i].formulaire.steps;
      let prev;
      for (; i >= 0; i--) {
        prev = res[i].formulaire.steps;
        if (prev != next) {
          break;
        } else {
          next = prev;
        }
        formList.push(res[i]);
      }
      if(this.buildingFormData.previousIndexForm === -1) {
        this.buildingFormData.previousIndexForm = 0;
      } else {
        this.buildingFormData.previousIndexForm = i;
      }
      this.buildingFormData.dynamicFormModels = formList;
    }
    setTimeout( r => {
      this.dataObj.nextFormData.init = true;
    }, TIME_MIN_X_REQUEST)
    this.buildFromEnum(null);
  }

  anyLastIndexForm(d: DynamicFormModel[]) {
    return (this.buildingFormData.lastIndexForm < d.length);
  }

  anyPreviousIndexForm(d: DynamicFormModel[]) {
    return (this.buildingFormData.previousIndexForm > 0);
  }

  initAllCashOutForm() {
    this.allCachOutForm = this.fb.group({
      identityType: ['', [Validators.required]],
      identityNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
      valueCode: [''],
      serviceItemId: [''],
      receivedAmount: [''],
      numberAccount: [''],
      receiverNumTel: [''],
      senderId: [''],
      receiverId: ['']
    });
  }

  sendRetraitCode(valid: boolean) {
    if (valid) {
      this.loadingCodeForm = true;

      setTimeout(() => {
        this.loadingCodeForm = false;
        this.retraitCode.reset();
      }, 1000);
    }
  }

  //For All cash out
  sendAllCashOut(valid: boolean) {
    if (valid) {
      this.loadingAllCashOut = true;

      setTimeout(() => {
        this.loadingAllCashOut = false;
        this.allCachOutForm.reset();
      }, 1000);
    }
  }

  /**
   * @see ValidationFormService#valider
   */
  confirmer(d: DataFormDynamic, dialog: MatDialog,): any {
    console.log('## confirmation retrait code complet');
    this.data.cashDataModel.dataForm = d;
    dialog.open(RetraitCodeCompletInfosComponent, {
      minWidth: SIZE_MIN_POPUP,
      minHeight: SIZE_MEDIUM_POPUP,
      panelClass: CONTAINER_DIALOG_POPUP,
      data: this.data
    });
  }

  //Valide All Cash Out
  DoneAllCachOutForm(forModal: any) {
    const code = this.data.cashDataModel.dataCode.code;
    const data = this.getFormData(this.dataObj.nextFormData.formulaire);
    data.set('serviceItemId', '' + this.data.cashDataModel.dataCode.serviceItemId);
    if(!data.get('sentAmount')) {
      data.set('sentAmount', this.data.cashDataModel.getCode().amount);
    }
    data.set('valueCode', code);
    data.set('numberAccount', this.accountNumber);
    data.set('principal', PRINCIPAL.ZERO + '');
    this.showKeys(data);
    this.dataObj.data = data;
    this.dataObj.forModal = forModal;
    this.confirmer(this.dataObj, this.dialog);

    /*this.transactionService.withdrawalv2(data).subscribe((response) => {
      const rep = response.body;
      console.log('### SUCCESS Retrait ALL CASH OUT', rep);
      this.manageMessageWhenSucceed(rep);
      this.showDetails(modalRetaitCodeBody,
        'Resultats du retrait CODE COMPLET', null,
        { closeButton: true, overlayClose: false });
      this.dataObj.nextFormData.formulaire.reset();
    }, err => {
      console.log('### ERROR Retrait ALL CASH OUT', err);
      this.manageMessageWhenError();
    });*/
  }


  DisableRetraitCodeSuccess() {
    this.data.cashDataModel.setElement(this.cashKey.appAllCashOut, false);
    this.data.cashDataModel.setElement(this.cashKey.retraitCodeValide, true);
  }

  retraitCash() {
    //GetMapping("api/codes/valueCode/{code}")
    console.log('### RETRAIT', this.retraitCode.value.envoiCode);
    this.codeService.findByCode(this.retraitCode.value.envoiCode)
      .subscribe((result) => {
        console.log('### RETRAIT CASH RESULT', result);
        this.data.cashDataModel.setCode(result.body);
        this.retraitCode.reset();
       // this.retraitCodeSuccess();
        //this.openModal(modalRetaitCodeBody,"Retrait Code Result");
      }, err => {
        console.log(err);
      });
  }

  getCode() {
    return this.data.cashDataModel.getCode();
  }

  getDataFromForm(): ITransaction {
    const code = this.data.cashDataModel.getCode();
    const tr: ITransaction = new Transaction();
    tr.valueCode = code.valueCode;
    tr.serviceItemId = 101;
    tr.receiverNumTel = code.receiverNumTel;
    tr.numberAccount = this.accountNumber;
    tr.senderId = code.senderId;
    tr.receiverId = code.receiverId;
    tr.password = this.allCachOutForm.value.password;
    tr.receivedAmount = this.data.cashDataModel.getCode().amount;
    const IDT = this.allCachOutForm.value.identityType;
    const IDN = this.allCachOutForm.value.identityNumber;
    const others = '{"typeIdentity":' + '"' + IDT + '",'
      + '"identityNumber":' + '"' + IDN + '"' + '}';
    tr.others = others;
    return tr;
  }

  /**
   * Affiche les détails de la transaction.
   * @param modal
   * @param title
   * @param footer
   * @param options
   */
  showDetails(modal, title: string, footer, options) {
    console.log('## showDetails');
    console.log('## modal: ', modal);
    console.log('## title: ', title);
    setTimeout(() => {
      this.openModal(modal, title, footer, options, POPUP_CONTAINER_CLASS);
    }, 0);
  }

  resetRetraitCodeForm() {
    this.retraitCode.reset();
    this.loadingCodeForm = false;
  }

  //All Cash Out Reset
  ResetAllCashOut() {
    this.allCachOutForm.reset();
  }


  getCurrentCuser() {
    this.cUserService.findOneByUserLogin(this.CurentUser.login)
      .subscribe((response) => {
        this.CurentUserCuser = response.body;
        console.log('CUSER POINT CASH', this.CurentUserCuser);
        //console.log("Current User",this.CurentUser);
        this.getCurrentMobileAccount();
      }, (err) => {
        console.log(err);
      });
  }

  getCurrentMobileAccount() {
    this.mAccountService.findAllAccountsByCUserId(this.CurentUserCuser.id)
      .pipe(
        filter((res: HttpResponse<IMobileAccount[]>) => res.ok),
        map((res: HttpResponse<IMobileAccount[]>) => res.body))
      .subscribe((val: IMobileAccount[]) => {
        console.log('## mobiles accounts: ', val);
        const res = val.filter(m => (m.status === STATUS.actived));
        console.log('## res:', res);
        this.cUserMobileAccount = res['0'];
        //  this.cUserMobileAccount = val['0'];
        this.accountNumber = this.cUserMobileAccount.numberAccount;
        console.log('NUMBER Account', this.accountNumber);
      }, err => {
        console.log(err);
      });
  }

  getCountryByLabel(label) {
    this.getData(`${BASE_URL}countries/label/${label}`, 'country', 'initCountryDestID');
  }

  initCountryDestID() {
    setTimeout(() => {
      this.CountryDestID = this.country.mId;
      console.log('### DESt Country ID', this.CountryDestID);
    }, 0);
  }

  copyInputMessage(inputElement) {
    console.log('## copy: ', inputElement);
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    console.log('## copy: ', inputElement.value);
  }

  /**
   * Affiche les détails de la transaction
   * lorsqu'elle a réussi.
   * @param modal
   * @param title
   * @param footer
   * @param options
   */
  showDetailsEnvoieCode(modal, title: string, footer, options) {
    console.log('## showDetailsEnvoieCode');
    console.log('## modal: ', modal);
    console.log('## title: ', title);
    setTimeout(() => {
      this.openModal(modal, title, footer, options, 'envoi-code');
    }, TIME_LONG_REQUEST);
  }

  /**
   * show or delete message infos.
   * @param response the response of the transaction.
   * @private
   */
  private manageMessageWhenError() {
    this.dataObj.successTransfert = false;
    this.loadingAllCashOut = false;
    this.dataObj.errorTransfert = true;
  }

  /**
   * show or delete message infos.
   * @param response the response of the transaction.
   * @private
   */
  private manageMessageWhenSucceed(response) {
    this.dataObj.errorTransfert = false;
    this.dataObj.successTransfert = true;
    this.loadingAllCashOut = false;
    this.finalAllCashOutVal = response;
    this.dataObj.reponseTransfert = response;
    this.dataObj.nextFormData.formulaire.reset();
  }

  //Initialiser les Country pour le Select
  initCountry() {
    console.log('## init country');
    setTimeout(() => {
      console.log('COUNTRIES size: ', this.countries?.length);
      this.countrylist = [];
      this.countries?.forEach(element => {
        console.log('## country element: ', element);
        this.countrylist.push({ 'label': element.label, 'value': element.label });
      });
    });
  }

  resetMessagesForm() {
    this.transfertCode.reset();
    this.loadingMessagesForm = false;
  }

  openModal<T>(body: Content<T>, header: Content<T> = null,
               footer: Content<T> = null, options: any = null,
               theClass?: string) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options,
      theClass: theClass
    });
  }

  closeModal() {
    console.log('## close envoi code');
    this.dialogRef.close();
  }

  isInvalid(): boolean {
    return this.formService.isInvalidForm(this.transfertCode);
  }

  isRequired(column: string): boolean {
    return this.formService.isRequired(this.transfertCode, column);
  }

  isInvalidDirtyOrtouched(column: string): boolean {
    return this.formService.isInvalidDirtyOrTouched(this.transfertCode,
      column);
  }

  getMinLength(column: string): number {
    return this.formService.getMinLength(this.transfertCode, column);
  }

  getMaxLength(column: string): number {
    return this.formService.getMaxLength(this.transfertCode, column);
  }

  hasErrorEmail(column: string): boolean {
    return this.formService.hasErrorEmail(this.transfertCode, column);
  }

  hasErrorPattern(column: string): boolean {
    return this.formService.hasErrorPattern(this.transfertCode, column);
  }

  hasErrorMinLength(column: string): boolean {
    return this.formService.hasErrorMinLength(this.transfertCode, column);
  }

  hasErrorMaxLength(column: string): boolean {
    return this.formService.hasErrorMaxLength(this.transfertCode, column);
  }
}
